import { Banknote, Smartphone, CreditCard } from "lucide-react";

export type PosPaymentMethod = "cash" | "razorpay" | "gpay" | "upi";

type PaymentSectionV2Props = {
  value: PosPaymentMethod;
  onChange: (m: PosPaymentMethod) => void;
};

const methods: { id: PosPaymentMethod; label: string; icon: typeof Banknote }[] = [
  { id: "cash", label: "Cash", icon: Banknote },
  { id: "upi", label: "UPI", icon: Smartphone },
  { id: "gpay", label: "GPay", icon: Smartphone },
  { id: "razorpay", label: "Razorpay", icon: CreditCard },
];

export function PaymentSectionV2({ value, onChange }: PaymentSectionV2Props) {
  return (
    <div className="grid grid-cols-4 gap-2">
      {methods.map((m) => {
        const active = value === m.id;
        const Icon = m.icon;
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => onChange(m.id)}
            className={`flex min-w-0 flex-col items-center gap-1 rounded-xl p-2 text-center text-[11px] font-medium leading-tight transition-all sm:p-3 sm:text-xs ${
              active ? "bg-primary text-primary-foreground" : "bg-card text-foreground hover:bg-muted"
            }`}
          >
            <Icon className="h-4 w-4 shrink-0 sm:h-5 sm:w-5" />
            <span className="truncate">{m.label}</span>
          </button>
        );
      })}
    </div>
  );
}
